exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".app---3vTSy {\n  height: 100vh;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column; }\n\n.footer---NcHZ2 {\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  -webkit-box-flex: 0;\n      -ms-flex-positive: 0;\n          flex-grow: 0; }\n\n.footer---NcHZ2 p {\n    font-size: 16px !important;\n    font-weight: 500 !important;\n    padding-top: 5px;\n    padding-left: 6px !important; }\n\n.container-wrapper---3U5Hh {\n  height: calc(100vh - 120px);\n  position: relative;\n  margin-bottom: 0.01px !important;\n  border-radius: 5px 5px 0.01px 0.01px;\n  min-width: 1242px; }\n\n@media screen and (max-width: 1220px) {\n    .container-wrapper---3U5Hh {\n      margin: 0.001px !important; } }\n\n.footer---NcHZ2 > * {\n  margin: 0 8px; }\n", ""]);

// exports
exports.locals = {
	"app": "app---3vTSy",
	"footer": "footer---NcHZ2",
	"container-wrapper": "container-wrapper---3U5Hh"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./containers/app/entry-app.scss
// module id = awYd
// module chunks = 1